import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { toast } from "react-toastify"

export const postComplaint = createAsyncThunk(
    "complaint/postComplaint",
    async ({ formData, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/complaints`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                })
            if (response.data.status) {
                return response.data
            }
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


const initialState = {
    isLoading: false,
}

const complaintSlice = createSlice({
    name: "complaint",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(postComplaint.pending, (state) => {
            state.isLoading = true
        })
            .addCase(postComplaint.fulfilled, (state, action) => {
                state.isLoading = false

            })
            .addCase(postComplaint.rejected, (state, action) => {
                state.isLoading = false
                toast.error(action.payload.message || "Failed to post complaint")
            })
    }

});

export default complaintSlice.reducer;